// Midtrans Snap loader - dynamically loads snap.js based on environment
let _loaded = null;

export function loadSnap({ clientKey, isProduction }) {
  if (_loaded) return _loaded;
  _loaded = new Promise((resolve, reject) => {
    if (window.snap) return resolve(window.snap);
    const script = document.createElement("script");
    script.src = isProduction
      ? "https://app.midtrans.com/snap/snap.js"
      : "https://app.sandbox.midtrans.com/snap/snap.js";
    script.setAttribute("data-client-key", clientKey || "");
    script.onload = () => (window.snap ? resolve(window.snap) : reject(new Error("Snap failed to load")));
    script.onerror = () => reject(new Error("Snap script failed to load"));
    document.head.appendChild(script);
  });
  return _loaded;
}
